/* The full collection is readable before enhancement and without JavaScript. */
(() => {
  const initCaptures = (root) => {
    const dialog = root.querySelector('[data-rider-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const image = dialog.querySelector('[data-capture-image]');
    const viewport = dialog.querySelector('[data-capture-viewport]');
    const zoom = dialog.querySelector('[data-capture-zoom]');
    const close = dialog.querySelector('[data-capture-close]');
    const source = dialog.querySelector('[data-capture-source]');
    let opener;
    let previousOverflow;
    const resetZoom = () => {
      viewport.classList.remove('is-zoomed');
      image.style.width = '';
      zoom.setAttribute('aria-pressed', 'false');
      zoom.textContent = zoom.dataset.zoomIn;
      viewport.scrollTo(0, 0);
    };
    root.querySelectorAll('[data-rider-capture]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = link;
        const thumbnail = link.querySelector('img');
        image.src = link.href;
        image.alt = thumbnail.alt;
        image.width = Number(thumbnail.getAttribute('width'));
        image.height = Number(thumbnail.getAttribute('height'));
        dialog.querySelector('[data-capture-heading]').textContent = link.dataset.captureTitle;
        source.href = link.dataset.sourceUrl;
        source.textContent = link.dataset.sourceLabel;
        resetZoom();
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        close.focus({ preventScroll: true });
      });
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      resetZoom();
      document.documentElement.style.overflow = previousOverflow || '';
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    zoom.addEventListener('click', () => {
      if (zoom.getAttribute('aria-pressed') === 'true') {
        resetZoom();
      } else {
        image.style.width = `${Math.max(image.naturalWidth, viewport.clientWidth) * 1.75}px`;
        viewport.classList.add('is-zoomed');
        zoom.setAttribute('aria-pressed', 'true');
        zoom.textContent = zoom.dataset.zoomOut;
      }
    });
  };
  const init = (root) => {
    if (root.dataset.ridersReady) return;
    root.dataset.ridersReady = 'true';
    initCaptures(root);
    const filters = root.querySelector('[data-rider-filters]');
    if (!filters) return;
    const buttons = [...filters.querySelectorAll('button[data-filter]')];
    const cards = [...root.querySelectorAll('[data-rider-category]')];
    const status = root.querySelector('[data-rider-status]');
    const pagination = root.querySelector('[data-rider-pagination]');
    const more = root.querySelector('[data-rider-more]');
    const pageSize = Math.max(1, Number(root.dataset.riderPageSize) || 12);
    let limit = pageSize;
    let current = 'all';
    const render = () => {
      const chosen = buttons.find((button) => button.dataset.filter === current) || buttons[0];
      const matching = cards.filter((card) => chosen.dataset.filter === 'all' || card.dataset.riderCategory === chosen.dataset.filter);
      const visible = new Set(matching.slice(0, limit));
      cards.forEach((card) => { card.hidden = !visible.has(card); });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === chosen)));
      status.textContent = (root.dataset.countTemplate || '[shown] of [total] rider stories')
        .replace('[shown]', String(visible.size)).replace('[total]', String(matching.length));
      status.hidden = false;
      if (more && pagination) {
        const complete = visible.size === matching.length;
        pagination.hidden = matching.length <= pageSize;
        more.setAttribute('aria-disabled', String(complete));
        more.textContent = complete ? more.dataset.completeLabel : more.dataset.moreLabel;
      }
    };
    const select = (category) => {
      current = buttons.some((button) => button.dataset.filter === category) ? category : 'all';
      limit = pageSize;
      render();
    };
    buttons.forEach((button) => button.addEventListener('click', () => select(button.dataset.filter)));
    more?.addEventListener('click', () => {
      if (more.getAttribute('aria-disabled') === 'true') return;
      limit += pageSize;
      render();
    });
    filters.hidden = false;
    select(new URLSearchParams(window.location.search).get('ride') || 'all');
  };
  document.querySelectorAll('[data-rider-stories]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-rider-stories]').forEach(init));
})();
